import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CommandBase } from './../../model/command';
import { ProgressBarService } from '../progress-bar.service';
import { ProgressState } from '../../model/progress-state';

@Injectable()
export class CommandDispatcher {
  constructor(private _progressBar: ProgressBarService) {}

  private _commandPipe = new Subject<CommandBase>();
  private dispatchedCommands = new Set<string>();

  commands = this._commandPipe.asObservable();

  sendCommand(command: CommandBase): void {
    if (this._progressBar.currentState === ProgressState.Active) return;

    // Check if the command has already been dispatched
    if (this.dispatchedCommands.has(command.id)) {
      return;
    }

    // Add the command to the set of dispatched commands
    this.dispatchedCommands.add(command.id);

    this._commandPipe.next(command);

    // Remove the command from the set of dispatched commands
    // You can do this in a finally block or after a Promise resolves or rejects,
    // depending on how you're dispatching the command
    this.dispatchedCommands.delete(command.id);
  }
}
